import React from 'react';
import { type IconType } from 'react-icons';
import { MdKeyboardArrowDown } from 'react-icons/md';

import { QuestionFAQProps } from '@/types/props';

const Question: React.FC<
  QuestionFAQProps & { icon: IconType; index: number }
> = ({ icon: Icon, index, isActive, onClick, question }) => {
  return (
    <button
      className={`flex w-full cursor-pointer items-center gap-4 px-4 py-4 text-left transition-colors duration-200 sm:gap-5 sm:px-5 sm:py-5 ${
        isActive ? 'bg-greenSecondary/[0.04]' : 'hover:bg-gray-50/60'
      }`}
      onClick={onClick}
      type='button'
    >
      <span
        className={`flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-full transition-all duration-300 sm:h-12 sm:w-12 ${
          isActive
            ? 'tracking-pill text-white shadow-pill ring-2 ring-greenSecondary/35'
            : 'bg-backgroundGreen text-white shadow-[0_4px_14px_rgba(9,45,54,0.2)]'
        }`}
      >
        <Icon aria-hidden className='h-5 w-5' />
        <span className='sr-only'>{index + 1}</span>
      </span>

      <span
        className={`min-w-0 flex-1 break-words font-headings text-[15px] font-semibold leading-snug sm:text-base ${
          isActive ? 'text-backgroundGreen' : 'text-gray-700'
        }`}
      >
        <span
          aria-hidden
          className={`mb-1 block text-[10px] font-semibold uppercase tracking-[0.2em] ${
            isActive ? 'text-greenSecondary' : 'text-greenSecondary/55'
          }`}
        >
          {String(index + 1).padStart(2, '0')}
        </span>
        {question}
      </span>

      <span
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
          isActive
            ? 'rotate-180 bg-greenSecondary/10 text-greenSecondary'
            : 'bg-gray-100 text-gray-500'
        }`}
      >
        <MdKeyboardArrowDown className='h-5 w-5' />
      </span>
    </button>
  );
};

export default Question;
